<button mat-icon-button class="app-menu-button back-button" (click)="showHistoric()">
  <mat-icon svgIcon="history"></mat-icon>
</button>
